import React, { useState } from 'react';
import SplashScreen from './components/SplashScreen';
import CustomCursor from './components/CustomCursor';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import MarqueeText from './components/MarqueeText';
import SkillsSection from './components/SkillsSection';
import AboutSection from './components/AboutSection';
import PortfolioSection from './components/PortfolioSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [showSplash, setShowSplash] = useState(true);

  const handleSplashComplete = () => {
    setShowSplash(false);
  };

  return (
    <div className="App">
      <CustomCursor />
      {showSplash && <SplashScreen onComplete={handleSplashComplete} />}
      <Navigation />
      <HeroSection />
      <MarqueeText text="Graphics / SaaS Web & App Development / YouTube Automation / AI-Driven Finance Systems / Automation Workflows / Chatbot Development" />
      <SkillsSection />
      <AboutSection />
      <MarqueeText text="Technical Excellence ✱ Creative Innovation ✱ Execution Quality ✱ Problem Solving" />
      <PortfolioSection />
      <TestimonialsSection />
      <FAQSection />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default App;